export const endpointBase = "https://kdhkdsv558.execute-api.eu-central-1.amazonaws.com/dev";

export const personalPut = endpointBase + "/personal/put";
export const personalAcl = endpointBase + "/personal/acl";
